import { Controller } from "stimulus"
import { fetchJSON } from "../lib/fetch_json"

export default class extends Controller {
  static targets = ["list", "emptyState"]
  static values = { createUrl: String, reorderUrl: String }

  async addPackage() {
    try {
      const nextOrder = this.listTarget.querySelectorAll(".package-row").length + 1
      const data = await fetchJSON(this.createUrlValue, {
        method: "POST",
        body: {
          package: {
            name: "New Package",
            price: "0.00",
            sort_order: nextOrder
          }
        }
      })

      if (data.errors) {
        alert(data.errors.join(", "))
        return
      }

      // Insert the rendered row HTML
      this.listTarget.insertAdjacentHTML("beforeend", data.html)

      // Hide empty state
      if (this.hasEmptyStateTarget) {
        this.emptyStateTarget.classList.add("d-none")
      }

      // Focus the name field of the new row
      const newRow = this.listTarget.lastElementChild
      const nameInput = newRow?.querySelector('input[data-field-name="name"]')
      if (nameInput) {
        nameInput.select()
        nameInput.focus()
      }

      // Dispatch completion update
      document.dispatchEvent(new CustomEvent("opp-editor:saved", {
        detail: { section: "tickets", completion: data.completion }
      }))
    } catch (e) {
      alert("Failed to add ticket: " + e.message)
    }
  }

  handleRowDeleted(event) {
    // Check if list is now empty
    const rows = this.listTarget.querySelectorAll(".package-row")
    if (rows.length === 0 && this.hasEmptyStateTarget) {
      this.emptyStateTarget.classList.remove("d-none")
    }
  }
}
